<template>
	<div>
		<div class="top">
			{{config.name}}
		</div>
		<div style="width: 100%;border-bottom: 3px solid #0162B3;">
		</div>
		<div class="lo">
			<div style="width: 1200px;height: 142px;margin: 0 auto;">
				<div style="float: left;width:659px;height:79px ;margin-top:45px;">
					<img :src="cdnurl+config.logo_big" style="width:659px;height:auto;" />
				</div>
				<div style="float: right;margin-top: 56px;margin-right: 10px;">
					<div style="width: 330px;height: 38px;">
						<div style="float: left;">
							<img src="https://files.gsjtpxzx.com/public/assets/front/image/8.png"
								style="width: 115px;height: 30px;">
						</div>
						<div style="float: left;font-size: 14px;color: rgba(0,0,0,0.85);margin-left: 12px;">
							<div>
								客服热线：
								<span style="color: #0361B1;">
									{{config.order_phone}}
								</span>
							</div>
							<div>
								技术支持：
								<span style="color: #0361B1;">
									{{config.order_phone}}
								</span>
							</div>
						</div>
					</div>
					<div
						style="height: 14px;font-size: 14px;color: rgba(0,0,0,0.85);letter-spacing: 0;margin-top: 11px;">
						咨询时间：{{config.consultation_time}}
					</div>
				</div>
			</div>
		</div>
		<div style="width: 100%;height:3px;background: #fff;">
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				config: {
					name: '',
					logo_big: ''
				},
				cdnurl: this.$cdn
			};
		},
		created() {
			this.getConfig()
		},
		methods: {
			//获取配置文件
			getConfig() {
				this.$http({
						method: 'POST',
						url: '/user/getConfig',
						headers: {
							requireAuth: false // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						console.log(response)
						if (response.code == 1) {
							this.config = response.data
						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
		}
	};
</script>

<style>
	.top {
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		color: rgba(255, 255, 255, 0.85);
		padding-left: 366px;
		background: #1476D1;
	}

	.lo {
		width: 100%;
		height: 141px;
		background-image: url(https://files.gsjtpxzx.com/public/assets/front/image/6.png);
		background-size: 100% 141px;
	}
</style>
